module.exports = __webpack_public_path__ + "static/fonts/Metric-R-regular.35ff52e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-R-regular.woff2
// module id = WJ1Z
// module chunks = 88